import { subDays, subHours } from 'date-fns'
import { WORK_SECONDS_OF_CLOCK } from '../../../../constants/Time'

const now = new Date().getTime()

export const tasks = [
  {
    breakSeconds: 0,
    createdDateTime: now,
    estimateSeconds: 2 * WORK_SECONDS_OF_CLOCK,
    id: 'c53f78ff-8a00-4aac-85fd-3dbae39a5255',
    isArchived: false,
    isBreaking: false,
    isComplete: false,
    title: 'My First Task',
    updatedDateTime: now,
    workHistory: [],
    workSeconds: 0,
  },
  {
    breakSeconds: 0,
    createdDateTime: subHours(now, 2).getTime(),
    estimateSeconds: 4 * WORK_SECONDS_OF_CLOCK,
    id: 'befbb846-7467-499a-914f-a3b1c4f58a28',
    isArchived: false,
    isBreaking: false,
    isComplete: true,
    title: 'My Second Task',
    updatedDateTime: subHours(now, 2).getTime(),
    workHistory: [subHours(now, 9).getTime(), subHours(now, 5).getTime(), subHours(now, 4).getTime(), subHours(now, 3).getTime()],
    workSeconds: 0,
  },
  {
    breakSeconds: 0,
    createdDateTime: subHours(now, 2).getTime(),
    estimateSeconds: 5 * WORK_SECONDS_OF_CLOCK,
    id: 'befbb846-7467-499a-914f-a3b1c4f58a29',
    isArchived: false,
    isBreaking: true,
    isComplete: true,
    title: 'My Third Task',
    updatedDateTime: subHours(now, 2).getTime(),
    workHistory: [subHours(now, 5).getTime(), subHours(now, 3).getTime(), subHours(now, 2).getTime()],
    workSeconds: 0,
  },
  {
    breakSeconds: 0,
    createdDateTime: subDays(now, 3).getTime(),
    estimateSeconds: 3 * WORK_SECONDS_OF_CLOCK,
    id: 'befbb846-7467-499a-914f-a3b1c4f58a30',
    isArchived: true,
    isBreaking: false,
    isComplete: false,
    title: 'My Fourth Task',
    updatedDateTime: subDays(now, 3).getTime(),
    workHistory: [],
    workSeconds: 0,
  },
  {
    breakSeconds: 0,
    createdDateTime: subDays(now, 5).getTime(),
    estimateSeconds: 4 * WORK_SECONDS_OF_CLOCK,
    id: 'befbb846-7467-499a-914f-a3b1c4f58a31',
    isArchived: true,
    isBreaking: false,
    isComplete: true,
    title: 'My Fifth Task',
    updatedDateTime: subDays(now, 5).getTime(),
    workHistory: [subHours(subDays(now, 3), 1).getTime(), subHours(subDays(now, 4), 2).getTime(), subHours(subDays(now, 4), 3).getTime()],
    workSeconds: 0,
  },
  {
    breakSeconds: 0,
    createdDateTime: subDays(now, 8).getTime(),
    estimateSeconds: 5 * WORK_SECONDS_OF_CLOCK,
    id: 'befbb846-7467-499a-914f-a3b1c4f58a32',
    isArchived: false,
    isBreaking: true,
    isComplete: false,
    title: 'My Sixth Task',
    updatedDateTime: subDays(now, 8).getTime(),
    workHistory: [subHours(subDays(now, 9), 3).getTime(), subHours(subDays(now, 9), 1).getTime(), subHours(subDays(now, 8), 2).getTime()],
    workSeconds: 0,
  },
]
